import { Model } from "@bryntum/schedulerpro";

export class ResourceIntegrationsModel extends Model {
  static get $name() {
    return "ResourceIntegrationsModel";
  }

  declare key: string;
  declare value: string;
  declare resourceId: number;

  static get fields() {
    return ["key", "value", { name: "resourceId", dataSource: "resource", type: "number" }];
  }
}

// @ts-expect-error exposeProperties is an internal method
ResourceIntegrationsModel.exposeProperties();
